module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background-gradient _pdv-32px",
    attrs: {
      "id": "home-getting-start"
    }
  }, [_c('div', {
    staticClass: "lo-container"
  }, [_c('div', {
    attrs: {
      "id": "content"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-white _bdrd-1px u-rise-1 _pdh-8px _pdv-32px _pd-32px-sm"
  }, [_c('HomeGettingStartSetup', {
    staticClass: "_mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_tal-ct _dp-f _jtfct-ct"
  }, [_c('router-link', {
    staticClass: "bio-button -accent _w-256px u-rise",
    attrs: {
      "to": {
        name: 'Introduction'
      }
    }
  }, [_c('strong', [_vm._v("อ่านวิธีใช้งาน")])])], 1)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_tal-ct _mgbt-24px"
  }, [_c('h2', {
    staticClass: "_cl-primary _lh-100pct _mgbt-8px"
  }, [_vm._v("Quick Start")]), _vm._v(" "), _c('p', {
    staticClass: "_fs-5 _opct-60"
  }, [_vm._v("เริ่มต้นกับ Biomatic")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-be5cbe8c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/home/HomeGettingStart.vue
// module id = 144
// module chunks = 0